import React from 'react'
import styled from 'styled-components'
import { Calendar } from '@styled-icons/feather'
import { Location } from '@styled-icons/evil'
import { Bus2 } from '@styled-icons/remix-fill'
import ButtonTC from '../../../components/button-tc/button-tc'
import { device } from '../../../config/theme/breakpoints'
import ListRowFirst from './components/list-row-first/list-row-first'
import ListRowSecond from './components/list-row-second/list-row-second'
import volante from '../../../assets/img/volante.png'
import { UserPlus } from '@styled-icons/boxicons-regular'
import { RecordCircleFill } from '@styled-icons/bootstrap'
import { ThreeDotsVertical } from '@styled-icons/bootstrap'
import { LocationDot } from '@styled-icons/fa-solid'
import { Clock } from '@styled-icons/bootstrap'
import { ArrowRight } from '@styled-icons/bootstrap'
import CalendarTC from '../../../components/calendar-tc/calendar-tc'
import SelectTC from '../../../components/select-tc/select-tc'

const ContainerDestinations = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 20px;
`

const ContainerSearch = styled.div<{ hidden: boolean }>`
  width: 100%;
  display: ${p => p.hidden ? 'none' : 'block'};

  @media ${device.tablet}{
    width: 25%;
    display: ${p => p.hidden ? 'block' : 'none'};
  }
`
const ContainerData = styled.div`
  background: ${p => p.theme.palette.primary.main};
  border-radius: 15px;
  min-height: 100px;
  padding: 10px 12px;

  > div:nth-child(1){
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    
    > p {
      font-size: 13px;
      color: white;
      margin: 0;
    }
  }

  > div:nth-child(1) svg{
    max-width: 30px;
    color: ${p => p.theme.palette.secondary.main};
    
  }
`

const ContainerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const CustomRadio = styled.div<{ active: boolean }>`
  width: 20px;
  height: 20px;
  background: transparent;
  border-radius: 50%;
  border: 2px solid ${p => p.active ? p.theme.palette.secondary.main : 'white'};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  
  > div {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${p => p.active ? p.theme.palette.secondary.main : 'white'};
  }
`

const CustomButton = `
  width: 100%;
  margin-top: 20px;
  padding: 10px;

  > div {
    justify-content: center;
  }
`
const ContainerNote = styled.div`
  text-align: center;

  > p{
    font-size: 12px;
    color: white;
  }
`

const ContainerOption = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 15px auto;

  > div:nth-child(1), 
  > div:nth-child(2) {
    display: flex;
    flex-direction: row;
    gap: 10px;
    color: white;
    font-size: 12px;
  }
`

const ContainerBus = styled.div`
  width: 100%;

  @media ${device.tablet}{
    width: 32%;
  }
`

const ContainerHeaderFloor = styled.div`
  width: 100%;
  background: ${p => p.theme.palette.primary.main};
  border-radius: 20px 20px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  color: white;

  > img {
    max-width: 20px;
  }
`

const ContainertBusTop = styled.div``
const ContainertBusBottom = styled.div``

const ContainerFirstFloor = styled.div`
  background: ${p => p.theme.palette.text.grayFullLight};
  border-radius: 20px;
`
const ContainerSecondFloor = styled.div`
  background: ${p => p.theme.palette.text.grayFullLight};
  border-radius: 20px;
  margin-top: 20px;
`

const ContainerDestiny = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    padding: 15px 12px;
`
const ContainerIcons = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 10px;
    margin-right: 5px;

    > svg {
        max-width: 10px;

        :nth-child(1){
            color: ${p => p.theme.palette.text.secondary};
        }
        :nth-child(2){
            color: ${p => p.theme.palette.text.primary};
            margin-top: 5px;
            margin-bottom: 5px;
        }
        :nth-child(3){
            color: ${p => p.theme.palette.text.primary};
        }
    }
`
const ContainerText = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > div {
        font-size: 12px;
    }
    
    > div b {
        margin-right: 10px;
    }
`
const ContainerDuration = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    
    > svg {
        max-width: 12px;
        color: ${p => p.theme.palette.text.primary};
        margin-right: 5px;
    }

    > p {
        font-size: 12px;
        color: ${p => p.theme.palette.text.gray};
    }
`

const ContainerSummary = styled.div`
  width: 100%;

  @media ${device.tablet}{
    width: 30%;
  }
`
const ContainerDataSummary = styled.div`
  background: ${p => p.theme.palette.text.grayFullLight};
  border-radius: 20px;
  border: 1px solid #B1B1B1;
`

const ContainerTopRight = styled.div`
  background: #B1B1B1;
  border-radius: 20px 20px 0 0;
  color: white;
  text-align: center;
  padding: 4px;
`
const ContainerInfo = styled.div``
const ContainerInfoUsers = styled.div`
  width: 100%;
  background: white;
  padding 15px 12px;

  > div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    padding 8px 0;

    > p{
      margin: 0;
    }
    
    > p:nth-child(2){
      color: ${p => p.theme.palette.text.grayLight};
    }
  }
`

const ContainerTotal = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-around;
  align-items: center;
  padding: 15px 10px;

  > div {
    width: 50%;
  }

  > div h2, 
  > div h4,
  > div p {
    margin: 0;
  }

  > div h4 {
    color: ${p => p.theme.palette.text.gray};
    font-size: 15px;
  }
  
  > div p {
    color: ${p => p.theme.palette.text.grayLight};
    font-size: 12px;
  }

  > div h2 {
    color: ${p => p.theme.palette.secondary.main};
    font-size: 25px;
    text-align: center;
  }

  @media ${device.tablet}{
    > div {
      width: 100%;
    }
  }
`

const ContainerBottomRight = styled.div`
  border-radius: 0 0 20px 20px;
  background: ${p => p.theme.palette.primary.main};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  cursor: pointer;

  > svg{
    max-width: 20px;
    color: white;
  }

  > p {
    color: white;
    font-size: 15px;
  }

  :hover {
    background: #1EDE91;
  }
`

const ContainerTextTop = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  gap: 20px;
  flex-wrap: wrap;

  > h3 {
    color:  ${p => p.theme.palette.primary.main};
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;

    @media ${device.tablet}{
      width: 48%;
      justify-content: flex-end;
    }
  }

  > h3 svg {
    width: 20px;
    color:  ${p => p.theme.palette.secondary.main};
    margin: 0 10px;
  }

  > p{
    color:  ${p => p.theme.palette.text.grayLight};
    font-size: 12px;
    margin: 0;
    width: 100%;
    text-align: center;

    @media ${device.tablet}{
      width: 48%;
      text-align: left;
    }
  }
`
const customSelect = `
  width: auto;

  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  select::-ms-expand {
    display: none;
  }
`

interface IOwnProps {
  onClick: (step: number) => void
}

const SeadingComponent: React.FunctionComponent<IOwnProps> = ({
  onClick
}) => {
  const [statusType, setStatusType] = React.useState<string>('ida_vuelta')
  
  return (
    <>
      <ContainerTextTop>
        <h3>
          Lima
          <ArrowRight />
          Chiclayo
        </h3>
        <p>Miercoles 10 de Agosto</p>
      </ContainerTextTop>
      <ContainerDestinations>
          <ContainerSearch hidden={true}>
            <ContainerData>
              <div><Bus2 /> <p>Cambiar Destino</p></div>
              <ContainerOption>
                <div>
                  <CustomRadio active={statusType === 'ida_vuelta'} onClick={() => setStatusType('ida_vuelta')}><div /></CustomRadio>
                  <span>Ida y vuelta</span>
                </div>
                <div>
                  <CustomRadio active={statusType === 'ida'} onClick={() => setStatusType('ida')}><div /></CustomRadio>
                  <span>Solo ida</span>
                </div>
              </ContainerOption>
              <ContainerForm>
                <div>
                  <SelectTC
                    textHolder='Origen'
                    background='white'
                    icon={<Location />}
                    className={customSelect}
                    listOptions={['Trujillo', 'Lima','Trujillo']}
                  />
                </div>
                <div>
                  <SelectTC
                    textHolder='Destino'
                    background='white'
                    icon={<Location />}
                    className={customSelect}
                    listOptions={['Trujillo', 'Lima','Trujillo']}
                  />
                </div>
                <div>
                  <CalendarTC
                    icon={<Calendar />}
                    textHolder='Ida'
                    background='white'
                  />
                </div>
                <div>
                  <CalendarTC
                    icon={<Calendar />}
                    textHolder='Regreso'
                    background='white'
                  />
                </div>
                <div>
                  <ButtonTC text='Modificar Búsqueda' buttonStyle='secondary' className={CustomButton}/>
                </div>
                <ContainerNote><p>Nota: Si tiene algún inconveniente con su compra, comuníquese con nosotros al correo postventa@.pe en el horario de 6:30am a 10:30am de Lunes a Domingo.</p></ContainerNote>
              </ContainerForm>
              <p></p>
            </ContainerData>
          </ContainerSearch>
          <ContainerBus>
            <ContainertBusTop>
              <ContainerFirstFloor>
                <ContainerHeaderFloor>
                  <img src={volante} alt='volante' />
                  <p><b>Primer piso</b> - 160º</p>
                </ContainerHeaderFloor>
                <ListRowFirst />
              </ContainerFirstFloor>
            </ContainertBusTop>
            <ContainertBusBottom>
              <ContainerSecondFloor>
                <ContainerHeaderFloor>
                  <img src={volante} alt='volante' />
                  <p><b>Segundo piso</b> - 140º</p>
                </ContainerHeaderFloor>
                <ListRowSecond />
              </ContainerSecondFloor>
            </ContainertBusBottom>
          </ContainerBus>
          <ContainerSummary>
            <ContainerDataSummary>
              <ContainerTopRight><p><b>Buscama</b> 160º / 140º</p></ContainerTopRight>
              <ContainerInfo>
                <ContainerDestiny>
                    <ContainerIcons>
                        <RecordCircleFill />
                        <ThreeDotsVertical />
                        <LocationDot />
                    </ContainerIcons>
                    <ContainerText>
                        <div><b>09:00 am</b>Lima - Plaza Norte</div>
                        <div><b>06:20 pm</b>Chiclayo</div>
                    </ContainerText>
                    <ContainerDuration>
                        <Clock />
                        <p>Duración: 15 Hrs. 30 Min. Aproximadamente</p>
                    </ContainerDuration>
                </ContainerDestiny>
              </ContainerInfo>
              <ContainerInfoUsers>
                <div>
                  <p><b>Pasajero Nº</b></p>
                  <p>S/ 100.00</p>
                </div>
                <div>
                  <p><b>Pasajero Nº</b></p>
                  <p>S/ 100.00</p>
                </div>
                <div>
                  <p><b>Pasajero Nº</b></p>
                  <p>S/ 100.00</p>
                </div>
                <div>
                  <p><b>Pasajero Nº</b></p>
                  <p>S/ 100.00</p>
                </div>
              </ContainerInfoUsers>
              <ContainerTotal>
                <div>
                  <h4>Precio Total</h4>
                  <p>Tasas e impuestos incluidos</p>
                </div>
                <div>
                  <h2>S/ 400.00</h2>
                </div>
              </ContainerTotal>
              <ContainerBottomRight onClick={() => onClick(3)}>
                <p>Continuar con los pasajeros</p>
                <UserPlus />
              </ContainerBottomRight>
            </ContainerDataSummary>
          </ContainerSummary>
          <ContainerSearch hidden={false}>
            <ContainerData>
              <div><Bus2 /> <p>Cambiar Destino</p></div>
              <ContainerOption>
                <div>
                  <CustomRadio active={statusType === 'ida_vuelta'} onClick={() => setStatusType('ida_vuelta')}><div /></CustomRadio>
                  <span>Ida y vuelta</span>
                </div>
                <div>
                  <CustomRadio active={statusType === 'ida'} onClick={() => setStatusType('ida')}><div /></CustomRadio>
                  <span>Solo ida</span>
                </div>
              </ContainerOption>
              <ContainerForm>
                <div>
                  <SelectTC
                    textHolder='Origen'
                    background='white'
                    icon={<Location />}
                    className={customSelect}
                    listOptions={['Trujillo', 'Lima','Trujillo']}
                  />
                </div>
                <div>
                  <SelectTC
                    textHolder='Destino'
                    background='white'
                    icon={<Location />}
                    className={customSelect}
                    listOptions={['Trujillo', 'Lima','Trujillo']}
                  />
                </div>
                <div>
                  <CalendarTC
                    icon={<Calendar />}
                    textHolder='Ida'
                    background='white'
                  />
                </div>
                <div>
                  <CalendarTC
                    icon={<Calendar />}
                    textHolder='Regreso'
                    background='white'
                  />
                </div>
                <div>
                  <ButtonTC text='Modificar Búsqueda' buttonStyle='secondary' className={CustomButton}/>
                </div>
                <ContainerNote><p>Nota: Si tiene algún inconveniente con su compra, comuníquese con nosotros al correo postventa@.pe en el horario de 6:30am a 10:30am de Lunes a Domingo.</p></ContainerNote>
              </ContainerForm>
              <p></p>
            </ContainerData>
          </ContainerSearch>
      </ContainerDestinations>
    </>
  )
}

export default SeadingComponent